<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { Separator } from "~/components/ui/separator"
import { cn } from "~/lib/utils"

const { class: cl } = defineProps<{
    class?: HTMLAttributes["class"]
}>()

</script>

<template>
    <div :class="cn('w-full max-w-full px-4 sm:px-6 flex items-center justify-center gap-2', cl)">
        <Separator class="flex-1 max-w-32 md:max-w-64 bg-foreground/20" />
        <Separator class="size-1 shrink-0 bg-foreground/20 rounded-full" />
        <Separator class="flex-1 max-w-32 md:max-w-64 bg-foreground/20" />
    </div>
</template>